<script lang="ts">
    import ScenarioOneQuickCategoriesOne from './ScenarioOneQuickCategoriesOne.svelte';
    import { QuickCategories } from './QuickCategories';
    import { quickCategoriesConfig } from './QuickCategoriesConfig';
    import { planning, scenarioManager } from '../../../../stores/store';
    import type { QuickCategoriesIdType } from './QuickCategoriesConfig';
    import type { Assignment } from '../Assignment';

    export let assignments: Assignment[] | null = null;

    let quickCategories = new QuickCategories(quickCategoriesConfig);
    quickCategories.setCurrentId($planning.currentQuickCategoryId);

    let categories: any[] = [];

    $: {
        // console.log('quickCategories, counting');
        let categoriesToCount: QuickCategoriesIdType[] = [
            'to_assign',
            'to_approve',
            'to_send',
            'in_progress',
        ];
        let sections =
            assignments !== null ? assignments : $scenarioManager.getScenarioSections(false, true);
        categoriesToCount.forEach(cat => {
            quickCategories.reset(cat);
            sections.forEach(ass => {
                if (!ass.getQuickCategories().getCategories().length) {
                    ass.setQuickCategories(new QuickCategories(quickCategoriesConfig));
                }
                ass.updateQuickCategories();
                if (ass.isAdHoc()) {
                    // https://er.automapa.pl/issues/41990
                    //let adhocAdder = ass.getQuickCategories().getQuantity(cat);
                    //console.log('quickCategories, adhoc, reset', adhocAdder);
                    //quickCategories.reset(cat);
                    //quickCategories.incrementAdhoc(cat, adhocAdder);
                } else {
                    let adder = ass.getQuickCategories().getQuantity(cat);
                    let adhocAdder = ass.getQuickCategories().getAdhoc(cat);
                    // console.log('quickCategories, adhoc, else, add', adhocAdder);
                    quickCategories.incrementQuantity(cat, adder);
                    quickCategories.incrementAdhoc(cat, adhocAdder);
                }
            });
        });
        quickCategories = quickCategories;
    }

    $: categories = quickCategories.getCategories();
</script>

<div class="container-quick-categories">
    {#each categories as quickCategory, index}
        <ScenarioOneQuickCategoriesOne
            {...quickCategory}
            {quickCategories}
            on:click={() => {
                if (quickCategories.getCurrentId() === quickCategory.id) {
                    quickCategories.setCurrentId('');
                } else {
                    quickCategories.setCurrentId(quickCategory.id);
                }
                $planning.currentQuickCategoryId = quickCategories.getCurrentId();
                $planning.selectedAssignments = [];
                quickCategories = quickCategories;
            }}
        />
    {/each}
</div>

<style>
    .container-quick-categories {
        display: flex;
        justify-content: space-between;
        /*margin: 20px 0 10px 0;*/
        column-gap: 3%;
    }
</style>
